// extracted by mini-css-extract-plugin
export var trail = "styles-module__trail___Rjtxj";
export var showMoreButtonContainer = "styles-module__showMoreButtonContainer___CV3S1";